import React from "react";
import { Navigate, Route } from "react-router-dom";
import { all_routes } from "./all_routes";
import MainDashboard from "../feature-module/dashboard/Dashboard";
import Signin from "../feature-module/pages/login/signin";
import Sales from "../feature-module/sales";
import Purchases from "../feature-module/purchases";
import CreateSale from "../feature-module/sales/createsale";
import EditSale from "../feature-module/sales/editsale";
import Products from "../feature-module/inventory/products";
import CreateProduct from "../feature-module/inventory/products/createproduct";
import EditProduct from "../feature-module/inventory/products/editproduct";
import Categories from "../feature-module/inventory/categories";
import CreateCategory from "../feature-module/inventory/categories/createCategory";
import EditCategory from "../feature-module/inventory/categories/editCategory";
import Brands from "../feature-module/inventory/brands";
import Bays from "../feature-module/inventory/bays";
import Sizes from "../feature-module/inventory/sizes";
import Sections from "../feature-module/inventory/sections";
import PaymentHeads from "../feature-module/inventory/paymentheads";
import ServiceTypes from "../feature-module/inventory/servicetypes";
import DeliveryTypes from "../feature-module/inventory/deliverytypes";
import DeliveryTimeSlots from "../feature-module/inventory/deliverytimeslots";
import SalePersons from "../feature-module/people/salepersons";
import Customers from "../feature-module/people/customers";
import CustomerOrders from "../feature-module/people/customers/orders";
import Suppliers from "../feature-module/people/suppliers";
import Stores from "../feature-module/people/stores";
import Users from "../feature-module/usermanagement/users";
import RolesPermissions from "../feature-module/usermanagement/rolespermissions";
import Permissions from "../feature-module/usermanagement/permissions";
import States from "../feature-module/inventory/states";
import Cities from "../feature-module/inventory/cities";
import CreatePurchase from "../feature-module/purchases/createpurchase";
import EditPurchase from "../feature-module/purchases/editpurchase";
import StockTransfer from "../feature-module/stock/stocktransfer";
import CreateStockTransfer from "../feature-module/stock/stocktransfer/createstocktransfer";
import EditStockTransfer from "../feature-module/stock/stocktransfer/editstocktransfer";
import SaleInvoice from "../feature-module/sales/saleinvoice";
import OriginalSaleInvoice from "../feature-module/sales/originalsaleinvoice";
import DeliveryManagement from "../feature-module/deliverymanagement";
import DeliveryReceipt from "../feature-module/deliverymanagement/deliveryreceipt";
import ManageStock from "../feature-module/stock/managestock";
import AddStock from "../feature-module/stock/managestock/addStock";
import AdjustStock from "../feature-module/stock/managestock/adjustStock";
import RefundExchangePage from "../feature-module/refund-exchange/refundexchange";
import RefundReceipt from "../feature-module/refund-exchange/RefundReceipt";
import ExchangeReceipt from "../feature-module/refund-exchange/ExchangeReceipt";
import ReportBuilder from "../feature-module/reports/pages/ReportBuilder";
import ReportViewer from "../feature-module/reports/pages/ReportViewer";
import Dashboard from "../feature-module/reports/pages/Dashboard";
import ReportLibrary from "../feature-module/reports/pages/ReportLibrary";
import SystemSettings from "../feature-module/pages/system-settings";
import ProofOfDelivery from "../feature-module/proof-of-delivery";

const routes = all_routes;

export const publicRoutes = [
  {
    path: '/',
    name: 'Root',
    element: <Navigate to={routes.dashboard} />,
    route: Route,
  },
  {
    path: routes.dashboard,
    name: "home",
    element: <MainDashboard />,
    route: Route,
  },
  {
    path: routes.sales,
    name: "sales",
    element: <Sales />,
    route: Route,
  },
  {
    path: routes.createSale,
    name: "createSale",
    element: <CreateSale />,
    route: Route,
  },
  {
    path: routes.editSale + '/:id',
    name: "editSale",
    element: <EditSale />,
    route: Route,
  },
  {
    path: routes.viewSaleInvoice + '/:id',
    name: "viewSaleInvoice",
    element: <SaleInvoice />,
    route: Route,
  },
  {
    path: routes.viewOriginalSaleInvoice + '/:id',
    name: "viewOriginalSaleInvoice",
    element: <OriginalSaleInvoice />,
    route: Route,
  },
  {
    path: routes.purchases,
    name: "purchases",
    element: <Purchases />,
    route: Route,
  },
  {
    path: routes.createPurchase,
    name: "createPurchase",
    element: <CreatePurchase />,
    route: Route,
  },
  {
    path: routes.editPurchase,
    name: "editPurchase",
    element: <EditPurchase />,
    route: Route,
  },
  {
    path: routes.products,
    name: "products",
    element: <Products />,
    route: Route,
  },
  {
    path: routes.createProduct,
    name: "createProduct",
    element: <CreateProduct />,
    route: Route,
  },
  {
    path: routes.editProduct + '/:id',
    name: "editProduct",
    element: <EditProduct />,
    route: Route,
  },
  {
    path: routes.categories,
    name: "categories",
    element: <Categories />,
    route: Route,
  },
  {
    path: routes.createCategory,
    name: "createCategory",
    element: <CreateCategory />,
    route: Route,
  },
  {
    path: routes.editCategory + '/:id',
    name: "editCategory",
    element: <EditCategory />,
    route: Route,
  },
  {
    path: routes.brands,
    name: "brands",
    element: <Brands />,
    route: Route,
  },
  {
    path: routes.bays,
    name: "bays",
    element: <Bays />,
    route: Route,
  },
  {
    path: routes.sizes,
    name: "sizes",
    element: <Sizes />,
    route: Route,
  },
  {
    path: routes.sections,
    name: "sections",
    element: <Sections />,
    route: Route,
  },
  {
    path: routes.paymentHeads,
    name: "paymentHeads",
    element: <PaymentHeads />,
    route: Route,
  },
  {
    path: routes.serviceTypes,
    name: "serviceTypes",
    element: <ServiceTypes />,
    route: Route,
  },
  {
    path: routes.deliveryTypes,
    name: "deliveryTypes",
    element: <DeliveryTypes />,
    route: Route,
  },
  {
    path: routes.deliveryTimeSlots,
    name: "deliveryTimeSlots",
    element: <DeliveryTimeSlots />,
    route: Route,
  },
  {
    path: routes.states,
    name: "states",
    element: <States />,
    route: Route,
  },
  {
    path: routes.cities,
    name: "cities",
    element: <Cities />,
    route: Route,
  },
  {
    path: routes.salePersons,
    name: "salePersons",
    element: <SalePersons />,
    route: Route,
  },
  {
    path: routes.customers,
    name: "customers",
    element: <Customers />,
    route: Route,
  },
  {
    path: routes.customerOrders + '/:id',
    name: "customerOrders",
    element: <CustomerOrders />,
    route: Route,
  },
  {
    path: routes.suppliers,
    name: "suppliers",
    element: <Suppliers />,
    route: Route,
  },
  {
    path: routes.stores,
    name: "stores",
    element: <Stores />,
    route: Route,
  },
  {
    path: routes.users,
    name: "users",
    element: <Users />,
    route: Route,
  },
  {
    path: routes.roles,
    name: "roles",
    element: <RolesPermissions />,
    route: Route,
  },
  {
    path: routes.permissions,
    name: "permissions",
    element: <Permissions />,
    route: Route,
  },
  {
    path: routes.stockTransfers,
    name: "stockTransfers",
    element: <StockTransfer />,
    route: Route,
  },
  {
    path: routes.addStockTransfer,
    name: "addStockTransfer",
    element: <CreateStockTransfer />,
    route: Route,
  },
  {
    path: routes.editStockTransfer,
    name: "editStockTransfer",
    element: <EditStockTransfer />,
    route: Route,
  },
  {
    path: routes.deliveries,
    name: "deliveries",
    element: <DeliveryManagement />,
    route: Route,
  },
  {
    path: routes.viewDeliveryReceipt,
    name: "viewDeliveryReceipt",
    element: <DeliveryReceipt />,
    route: Route,
  },
  {
    path: routes.manageStock,
    name: "manageStock",
    element: <ManageStock />,
    route: Route,
  },
  {
    path: routes.addStock,
    name: "addStock",
    element: <AddStock />,
    route: Route,
  },
  {
    path: routes.stockAdjustment,
    name: "stockAdjustment",
    element: <AdjustStock />,
    route: Route,
  },
  {
    path: routes.refundExchange + '/:invoiceId/:operation?',
    name: "refundExchange",
    element: <RefundExchangePage />,
    route: Route,
  },
  {
    path: routes.viewRefundReceipt + '/:id',
    name: "viewRefundReceipt",
    element: <RefundReceipt />,
    route: Route,
  },
  {
    path: routes.viewExchangeReceipt + '/:id',
    name: "viewExchangeReceipt",
    element: <ExchangeReceipt />,
    route: Route,
  },
  {
    path: routes.reportBuilder,
    name: "reportBuilder",
    element: <ReportBuilder />,
    route: Route,
  },
  {
    path: routes.reportViewer,
    name: "reportViewer",
    element: <ReportViewer />,
    route: Route,
  },
  {
    path: routes.dashboard,
    name: "dashboard",
    element: <Dashboard />,
    route: Route,
  },
  {
    path: routes.reportLibrary,
    name: "reportLibrary",
    element: <ReportLibrary />,
    route: Route,
  },
  {
    path: routes.systemSettings,
    name: "systemSettings",
    element: <SystemSettings />,
    route: Route,
  },
];

export const authRoute = [
  {
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
];

export const unauthenticatedRoutes = [
  {
    path: routes.proofOfDelivery,
    name: "proofOfDelivery",
    element: <ProofOfDelivery />,
    route: Route,
  },
];
